import React from 'react';
import ContentEditor from 'components/ContentEditor';

interface DTBContentEditorProps {
  id: string;
  contentHTML: string;
  onSave: (html: string) => void;
  isEditable: boolean;
  manualId?: string;
}

/**
 * DTBContentEditor - A wrapper component that uses the unified ContentEditor
 * with appropriate feature flags based on whether a manual is associated with the DTB.
 *
 * When a DTB has an associated manual, users can insert text entities using
 * the $ trigger, sourced from the manual's GIQ questions.
 */
const DTBContentEditor: React.FC<DTBContentEditorProps> = ({
  id,
  contentHTML,
  onSave,
  isEditable,
  manualId,
}) => {
  // Check if DTB has a manual associated with it
  const hasManual = !!manualId;

  return (
    <ContentEditor
      id={id}
      contentHTML={contentHTML}
      onSave={onSave}
      isEditable={isEditable}
      manualId={manualId}
      textEntitiesEnabled={hasManual}
      trackChangesEnabled={false}
      crossReferencesEnabled={false}
      imagesEnabled={false}
      attachmentsEnabled={false}
    />
  );
};

export default DTBContentEditor;
